import React from "react";
import { User } from "../../shared";

export const UserContext = React.createContext<{
  id: string | null;
  user: User | null;
}>({ id: null, user: null });
